"use client";

import React, { useState, useEffect } from "react";
import axios from "axios";

export default function GoldDistributionList() {
  const apiUrl = process.env.REACT_APP_BACKEND_URL;

  const [pdfList, setPdfList] = useState([]);

  // Fetch only the PDF list
  const fetchPdfs = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/v1/gold-distribution/get`);
      setPdfList(response.data);
    } catch (error) {
      console.error("Error fetching PDFs:", error);
    }
  };

  useEffect(() => {
    fetchPdfs();
  }, []);

  return (
    <div className="min-h-screen p-6 ">
      <div className="flex  justify-between w-full mb-6">
        <h1 className="text-2xl font-bold text-start text-[#754C28]">
          Gold Distribution List – PDF Viewer
        </h1>
      </div>

      {/* PDF LIST UI ONLY */}
      <div className="grid grid-cols-2 sm:grid-cols-1 gap-6">
        {pdfList.length === 0 && (
          <p className="text-gray-600">No PDFs available.</p>
        )}

        {pdfList.map(pdf => (
          <div
            key={pdf.id}
            className="bg-white p-4 rounded shadow flex flex-col items-start"
          >
            <p className="font-semibold mb-2 text-start truncate max-w-[280px]">
              {pdf.pdf_url}
            </p>

            <a
              href={`${pdf.pdf_url}`}
              target="_blank"
              className="bg-blue-600 text-white px-3 py-1 rounded"
            >
              Open PDF
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
